export class HTMLElementRatioResizer {
	private static _initialized = false;
	static init() {
		if (this._initialized) {
			return;
		}
		this._initialized = true;
		new HTMLElementRatioResizer()._init();
	}
	constructor() {}
	private _init() {
		this._process();
		window.addEventListener('resize', this._process.bind(this));
	}
	private _process() {
		const elements: Element[] = [
			...document.getElementsByTagName('iframe'),
			// ...document.getElementsByTagName('lite-youtube'), // not necessary to resize those if the poster
		];
		for (let element of elements) {
			const ratio = element.getAttribute('ratio');
			if (ratio != null) {
				this._processElement(element, parseFloat(ratio));
			}
		}
	}
	private _processElement(element: Element, ratio: number) {
		const box = element.getBoundingClientRect();
		const expectedheight = box.width / ratio;
		(element as HTMLElement).style.height = `${expectedheight}px`;
	}
}
